export interface SecurityModel {
  name: string;
  read: boolean;
  write: boolean;
  delete: boolean;
  update: boolean;
}

export enum SecuritySections {
  FORM = 'FORM',
  FORM_SUBMISSION = 'FORM_SUBMISSION',
  REPORT = 'REPORT',
  PAYMENT_ACCOUNTS = 'PAYMENT_ACCOUNTS',
  USERS = 'USERS',
  ORGANIZATION = 'ORGANIZATION',
}

export const getSecuritySection = (security: SecurityModel[], section: SecuritySections): SecurityModel | null => {
  if (security) {
    const sectionIndex = security.findIndex((targetSection) => {
      return targetSection.name == section;
    });
    return security[sectionIndex];
  }
  return null;
};

export class Security implements SecurityModel {
  public name: string;
  public read: boolean;
  public write: boolean;
  public delete: boolean;
  public update: boolean;
  constructor() {
    this.name = '';
    this.read = false;
    this.write = false;
    this.delete = false;
    this.update = false;
  }
}
